module.exports = __webpack_public_path__ + "img/SL-M-140-160.e56657be.svg";